import React from "react";
import AgentData from "./components/agent-data.jsx";
import DispatchCards from "./components/dispatch-cards.jsx";
import DispatchNatures from "./components/dispatch-natures.jsx";
import DispatchPlaces from "./components/dispatch-places.jsx";
import DispatchNeighborhood from "./components/dispatch-neighborhood.jsx";
import DispatchAddress from "./components/dispatch-address.jsx";
import EncounterCards from "./components/encounter-cards.jsx";
import IndividualsSex from "./components/individuals-sex.jsx";
import IndividualsAgeRange from "./components/individuals-age-range.jsx";
import IndividualsOtherEncounters from "./components/individuals-other-encounters.jsx";
import VehiclesTypes from "./components/vehicle-types.jsx";
import VehiclesOthersEncounters from "./components/vehicles-others-encounters.jsx";
import BosCards from "./components/bos_cards.jsx";
import BosStatus from "./components/bos-status.jsx";
import BosNatures from "./components/bos-natures.jsx";
import BosReferral from "./components/bos-referral.jsx";
import ApprehensionCards from "./components/apprehension-cards.jsx";
import ApprehensionTypes from "./components/apprehension-types.jsx";
import BosConditions from "./components/bos-conditions.jsx";
const ReportContent = ({data, isLeader, collapsed}) => {
  return(
    <>
      <AgentData key={`agend-data-${collapsed}`} data={data.agent_data} isLeader={isLeader}/>
      <DispatchCards key={`dispatch-card-${collapsed}`} dispatchData={data.dispatch_cards}
                     dispatchAvgTime={data?.dispatch_avg_time}
                     dispatchOutsideSector={data?.dispatch_outside_sector}
                     percentFilledTooltip={data?.percent_filled_tooltip}
                     isLeader={isLeader}
                     boName={data?.bo_name}/>
      <DispatchNatures key={`dispatch-natures-${collapsed}`} data={data?.dispatch_natures}/>
      <DispatchPlaces key={`dispatch-places-${collapsed}`} data={data?.dispatch_place}/>
      <DispatchNeighborhood key={`dispatch-neighborhood-${collapsed}`} data={data?.dispatch_neighborhood}/>
      <DispatchAddress key={`dispatch-address-${collapsed}`} data={data?.dispatch_address}/>
      <EncounterCards key={`encounter-cards-${collapsed}`} data={data?.encounter_cards} teamEncounter={data?.team_encounter} isLeader={isLeader} boName={data?.bo_name}/>
      <IndividualsSex key={`individuals-sex-${collapsed}`} data={data?.individuals_sex}/>
      <IndividualsAgeRange key={`individuals-age-range-${collapsed}`} data={data?.individuals_age_range}/>
      <IndividualsOtherEncounters key={`individuals-other-encounters-${collapsed}`}  data={data?.individuals_others_encounters}/>
      <VehiclesTypes key={`vehicles-types-${collapsed}`} data={data?.vehicle_types}/>
      <VehiclesOthersEncounters key={`vehicles-others-encounters-${collapsed}`}  data={data?.vehicles_others_encounters}/>
      <BosCards key={`bo-cards-${collapsed}`} data={data?.bo_cards} bosTeams={data?.bo_teams} boName={data?.bo_name} isLeader={isLeader}/>
      <BosStatus key={`bos-status-${collapsed}`} data={data?.bo_status} boName={data?.bo_name}/>
      <BosNatures key={`bos-natures-${collapsed}`} data={data?.bo_natures} boName={data?.bo_name}/>
      <BosConditions key={`bos-conditions-${collapsed}`} data={data?.bo_conditions}/>
      <BosReferral key={`bos-referral-${collapsed}`} data={data?.bo_referral}/>
      <ApprehensionCards key={`apprehension-cards-${collapsed}`} data={data?.apprehension_cards} isLeader={isLeader}/>
      <ApprehensionTypes key={`apprehension-types-${collapsed}`} data={data?.apprehension_types}/>
      <div id="chart-tables"></div>
    </>
  )
}

export default ReportContent;